<template>
    <div>
        <input type="text" class="mt-3 form-control" @input="updateList" v-model="query"
               placeholder="جستجو">

        <div class="list-group mt-3">
            <div v-for="item in list" :key="item.id" class="p-2 pr-3 list-group-item"
                 :class="{'active': active ==item.id}" @click="itemClick(item)">
                <!-- Item -->
                <div style="clear: both" v-if="item.image">
                    <div style="float: right; width: 85px">
                        <img :src="item.image" style="width: 70px; height: 70px"/>
                    </div>
                    <div style="float: right; width: calc(100% - 155px)">
                        <h6 class="mt-1 ">{{item.title}}</h6>
                        <div class="mt-1">{{item.description}}</div>
                    </div>
                    <div style="float: right; width: 70px">
                        <small style="display: block" title="تاریخ ایجاد">
                            {{item.created_at| moment("jYYYY/jMM/jDD")}}
                        </small>
                        <small style="display: block" title="ساعت ایجاد">
                            {{item.created_at| moment("ساعت HH:mm")}}
                        </small>
                        <small v-if="item.status != '' " style="display: block; font-weight: bold" title="وضعیت">
                            {{item.status}}
                        </small>
                    </div>
                </div>
                <div style="clear: both" v-else>
                    <div style="float: right; width: calc(100% - 70px)">
                        <h6 class="mt-1 ">{{item.title}}</h6>
                        <div class="mt-1">{{item.description}}</div>
                    </div>
                    <div style="float: right; width: 70px">
                        <small style="display: block" title="تاریخ ایجاد">
                            {{item.created_at| moment("jYYYY/jMM/jDD")}}
                        </small>
                        <small style="display: block" title="ساعت ایجاد">
                            {{item.created_at| moment("ساعت HH:mm")}}
                        </small>
                        <small v-if="item.status != '' " style="display: block; font-weight: bold" title="وضعیت">
                            {{item.status}}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <pagination @changePage="updateList" v-model="link" :page="simplePaginate"></pagination>
    </div>
</template>

<script>


    import Pagination from "./Pagination";

    export default {
        name: "AdminDatalist",
        props: ['link', 'active'],
        components: {

            Pagination,

        },
        created: function () {

            //console.log('created page')
            this.updateList();
        },
        data: function () {
            return {
                list: null,
                simplePaginate: null,
                query: "",
            }
        },
        methods: {
            updateList: function () {

                this.axios.get(this.link, {
                    params: {search: this.query}
                })
                    .then(({data}) => {
                        // console.log(data);
                        this.simplePaginate = data;
                        this.list = data.data;
                    });
            },
            itemClick(item) {
                this.$emit('itemClick', item);
            }

        }
    }
</script>

<style scoped>
    .page-item:first-child .page-link {
        margin-left: 0;
        border-top-left-radius: 0.0rem;
        border-bottom-left-radius: 0.0rem;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }

    .page-item:last-child .page-link {
        border-top-right-radius: 0.0rem;
        border-bottom-right-radius: 0.0rem;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminDatalist.vue